import classNames from 'clsx';
import React from 'react';

import type { EventId } from '@swf/generated/types/api/sports';
import EventStatus from '@swf/sports/components/EventStatus/EventStatus';
import useParticipants from '@swf/sports/hooks/useParticipants';
import type { EventTypeId } from '@swf/sports/types/eventType';

import BackgroundImage from '../BackgroundImage/BackgroundImage';

import styles from './Unavailable.scss';

interface Props {
  name: string;
  eventId: EventId;
  eventTime: string;
  eventTypeId: EventTypeId;
}
const Unavailable: React.FC<Props> = ({ name, eventId, eventTime, eventTypeId }) => {
  const [teamAName, teamBName] = useParticipants(name) ?? [];

  return (
    <BackgroundImage eventTypeId={eventTypeId}>
      <div className={styles.wrapper}>
        <div className={styles.status}>
          <EventStatus inPlay canTurnInPlay startTime={eventTime} eventId={eventId} size="XSmall" />
        </div>
        <div className={classNames(styles.team, styles.teamA)}>{teamAName}</div>
        <div className={classNames(styles.team, styles.teamB)}>{teamBName}</div>
      </div>
    </BackgroundImage>
  );
};

export default Unavailable;
